import React, { useState } from "react";
import { Form, Collapse, Card, DatePicker, Col, Button, Row, Select } from "antd";
import jsonfile from "./localexpenses.json";
import { useHistory } from "react-router-dom";
import { CisUI } from "../../../../util/CISUI";
import "react-smart-data-table/dist/react-smart-data-table.css";
import Config from "../../../../util/config";
import SelectData from "../../../../util/selectdata";
import axios from "../../../../util/Api";
import IntlMessages from "../../../../util/IntlMessages";
import jsPDF from "jspdf";
import moment from "moment";

const { MonthPicker } = DatePicker;
const Panel = Collapse.Panel;

const LocalSummaryReport = () => {
  const formRef = React.createRef();
  const [state, setState] = useState({
    reqURL: Config.apiserver + jsonfile.urls.summary,
    filtervalue: "",
    reportTitle: "",
    reportData: [],
    totalContribution: 0,
    month: "",
    region: "",
    district: "",
    contribution: [],
    expenses: [],
    totalExpenses: 0,
    netTitheAfterExpense: 0,
    ddf: 0,
    NetTitheToDistrict: 0,
    missionOffering: 0,
    MinistryIncome: 0,
    Mckeowns: 0,
    InternalMissions: 0,
    NationalPrayer: 0,
    PENSOS: 0,
    netCashToDistrict: 0,
  });

  const history = useHistory();

  const [form] = Form.useForm();

  const handleMonthChange = (date) => {
    if (date) {
      const start = date.startOf("month");
      const end = date.endOf("month");
      form.setFieldsValue({ date: [start, end] });
    }
  };

  const onFinish = (values) => {
    let data = {
      region_id: values.region_id,
    };

    if (values.district_id) {
      data.district_id = values.district_id;
    }

    if (values.date) {
      data.date = values.date[0].format("YYYY-MM-DD") + "," + values.date[1].format("YYYY-MM-DD");
    }

    if (values.month) {
      data.month = values.month.format("YYYY-MM");
    }

    const qs = Object.keys(data)
      .map((key) => `${key}=${data[key]}`)
      .join("&");
    const qsup = qs.replaceAll("undefined", "");

    history.push("?" + qsup);
    const newURL = Config.apiserver + jsonfile.urls.summary + "?" + qsup;

    let reportTitle = "";
    if (values.date) {
      const WKR = CisUI().ParseDateFormat(values.date);
      reportTitle = "Between " + CisUI().DateFormat(WKR[0]) + " and " + CisUI().DateFormat(WKR[1]);
    } else if (values.month) {
      reportTitle = "Month of " + CisUI().getMonthNameTimeStamp(values.month);
    }

    document.getElementById("loader").style.display = "block";
    axios
      .get(newURL)
      .then((res) => {
        document.getElementById("loader").style.display = "none";
        if (res.data.status === 1) {
          const data = res.data.data;
          setState({
            reqURL: newURL,
            contribution: data.contribution,
            totalContribution: data.totalContribution,
            district: data.district,
            region: data.region,
            reportTitle: reportTitle,
            month: values.month ? CisUI().getMonthTitle(values.month.format("YYYY-MM-DD")) : "",
            expenses: data.expenses,
            totalExpenses: data.totalExpenses,
            netTitheAfterExpense: data.netTitheAfterExpense,
            ddf: data.ddf,
            NetTitheToDistrict: data.NetTitheToDistrict,
            missionOffering: data.missionOffering,
            MinistryIncome: data.MinistryIncome,
            Mckeowns: data.Mckeowns,
            InternalMissions: data.InternalMissions,
            NationalPrayer: data.NationalPrayer,
            PENSOS: data.PENSOS,
            netCashToDistrict: data.netCashToDistrict,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        document.getElementById("loader").style.display = "none";
      });
  };

  let searchView = "";
  if (jsonfile.has_search) {
    const districtData = SelectData("district");
    searchView = (
      <Card className="advance-search-card no-print">
        <Collapse accordion expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel header="Advance Search" key="1">
            <Form
              key={5}
              form={form}
              ref={formRef}
              {...CisUI().formItemLayout}
              name="advanced_search"
              className="ant-advanced-search-form"
              onFinish={onFinish}
            >
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item label="District" name="district_id">
                    <Select
                      showSearch
                      allowClear={true}
                      placeholder="Select district"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false
                      }
                    >
                      {districtData.map((items, index) => (
                        <Select.Option key={index} value={items.id}>
                          {items.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Month" name="month">
                    <MonthPicker
                      placeholder="Select month"
                      format="MM/YYYY"
                      style={{ width: "100%" }}
                      onChange={handleMonthChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Date Range" name="date">
                    <DatePicker.RangePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col lg={6} md={6} sm={12} xs={24} style={{ textAlign: "left", marginTop: "8px" }}>
                  <Button type="primary" className="searchbutton" htmlType="submit">
                    <i className="fas fa-search" /> <IntlMessages id={"Search"} />
                  </Button>
                </Col>
              </Row>
            </Form>
          </Panel>
        </Collapse>
      </Card>
    );
  }

  const print = () => {
    // window.print();
    window.open(
      Config.baseurl +
        "summaryreport.html?url=" +
        window.btoa(state.reqURL) +
        "&filename=district_summary_report&data=districtsummeryData&subtitle=" +
        state.reportTitle +
        "&rptype=districtsummaryreport",
      "_blank",
    );
  };

  const exportToPDF = () => {
    var doc = new jsPDF({
      putOnlyUsedFonts: true,
      orientation: "landscape",
      unit: "px",
    });

    // var doc = new jsPDF('l', 'px', 'letter');

    const pageWidth = doc.internal.pageSize.getWidth();

    const marginX = (pageWidth - 80) / 2;
    const xOffset = doc.internal.pageSize.width / 2;
    const user = localStorage.getItem("userData");
    const uj = JSON.parse(user);

    doc.addImage(Config.print_logourl, "PNG", marginX, 5, 80, 27);
    doc.text("Area Summary Report", xOffset, 37, { align: "center" });
    doc.setFontSize(12);
    doc.text(state.reportTitle, xOffset, 43, { align: "center" });
    doc.setFontSize(8);
    doc.text("Printed By : " + uj["name"], 20, 50, { align: "left" });
    doc.setFontSize(8);
    doc.text("Date/Time : " + moment().format("MM/DD/YYYY HH:mm"), 20, 55, { align: "left" });

    var content = document.getElementById("region_summary").innerHTML;

    doc.html(content, {
      margin: [40, 60, 40, 60],
      callback: function (doc) {
        doc.save("region_summary");
      },
      x: 20,
      y: 50,
    });
  };

  const listAction = () => (
    <div className="no-print">
      <a id="rploader" style={{ width: "40px", height: "40px", display: "none" }}>
        <img src="/assets/images/loader.svg" style={{ width: "40px", height: "40px" }} alt="loader" /> Please wait ...
      </a>
      {/*<Link to={"../"+jsonfile.urls.add} className="btn-text-adjust btn btn-circle-md" title="Add New">*/}
      {/*    <i className="fas fa-plus"/>*/}
      {/*</Link>*/}
      <button className="btn btn-export-pdf btn-circle-md" onClick={exportToPDF} title="Export to PDF">
        <i className="fas fa-file-pdf" />
      </button>
      <button onClick={print} className="btn btn-export-print btn-circle-md" title="Print">
        <i className="fas fa-print" />
      </button>
    </div>
  );

  const getExtra = <>{listAction()}</>;

  return (
    <>
      {searchView}
      <Card extra={getExtra}>
        {CisUI().showLoading}
        <div className="row">
          <div className="text-center col-md-12">
            <h3>District Summary Report</h3>
            <h2>{state.reportTitle}</h2>
          </div>
          <div className="col-md-6">
            <table>
              <tr>
                <th style={{ textAlign: "right" }}>Area :</th>
                <td>{state.region}</td>
              </tr>
              <tr>
                <th style={{ textAlign: "right" }}>Dsitrict :</th>
                <td>{state.district}</td>
              </tr>
            </table>
          </div>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Title</th>
              <th style={{ textAlign: "right" }}>Amount</th>
              <th style={{ textAlign: "right" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>TOTAL CONTRIBUTION RECEIVED (Gross Tithe & Offering) </th>
              <th style={{ textAlign: "right" }}></th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.totalContribution)}</th>
            </tr>

            <tr>
              <th>DISTRICT EXPENSES </th>
              <th style={{ textAlign: "right" }}></th>
              <th style={{ textAlign: "right" }}></th>
            </tr>
            {state.expenses.map((items, index) => (
              <tr>
                <td>{items.title}</td>
                <td style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(items.amount)}</td>
                <td style={{ textAlign: "right" }}></td>
              </tr>
            ))}
            <tr>
              <th>Total District Expenses</th>
              <th style={{ textAlign: "right" }}></th>
              <th style={{ textAlign: "right" }}>({CisUI().getCurrencyFormated1(state.totalExpenses)})</th>
            </tr>

            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Net Tithe After Local Expenses
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.netTitheAfterExpense)}</th>
            </tr>
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Less: District Development Fund (10%)
              </th>
              <th style={{ textAlign: "right" }}>({CisUI().getCurrencyFormated1(state.ddf)})</th>
            </tr>
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Net Tithe to Area
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.NetTitheToDistrict)}</th>
            </tr>
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Add : Missions Offering
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.missionOffering)}</th>
            </tr>
            <tr style={{ display: "none" }}>
              <th colSpan={2} style={{ textAlign: "right" }}>
                <a href="#">Add : Ministry Income</a>
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.MinistryIncome)}</th>
            </tr>
            <tr style={{ display: "none" }}>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Add : Mckeowns
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.Mckeowns)}</th>
            </tr>
            <tr style={{ display: "none" }}>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Add : Internal Missions
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.InternalMissions)}</th>
            </tr>
            <tr style={{ display: "none" }}>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Add : National Prayer
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.NationalPrayer)}</th>
            </tr>
            <tr style={{ display: "none" }}>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Add : PENSOS
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.PENSOS)}</th>
            </tr>
            {/*<tr>*/}
            {/*    <th colSpan={2} style={{textAlign : 'right'}}>Add : Other Funds(Mckeowns, Internal Missions, National Prayer, & PENSOS)</th>*/}
            {/*    <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(0)}</th>*/}
            {/*</tr>*/}
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                AMOUNT SENT TO AREA
              </th>
              <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.netCashToDistrict)}</th>
            </tr>
          </tbody>
        </table>
      </Card>
    </>
  );
};

export default LocalSummaryReport;
